import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SelectedFilters } from 'src/app/portfolio/state/portfolioGeneralSlice';

export type GnrFiltersState = {
    selectedFilters: SelectedFilters;
    search: string;
    sort: string | null;
    sortDir: string | null;
    page: number;
};

const initialState: GnrFiltersState = {
    selectedFilters: [],
    search: '',
    sort: null,
    sortDir: null,
    page: 1,
};

const gnrFiltersSlice = createSlice({
    name: 'gnrFilters',
    initialState,
    reducers: {
        updateGnrFilters: (state, action: PayloadAction<SelectedFilters>) => {
            state.selectedFilters = action.payload;
        },
        resetGnrFilters: state => {
            state.selectedFilters = [];
        },
        syncGnrState: (_state, action: PayloadAction<GnrFiltersState>) => action.payload,
        clearAllGnrState: () => initialState,
    },
});

export const { updateGnrFilters, resetGnrFilters, syncGnrState, clearAllGnrState } = gnrFiltersSlice.actions;
export default gnrFiltersSlice.reducer;
